"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shipment = exports.ShipmentStatus = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const order_entity_1 = require("./order.entity");
const shipment_line_item_entity_1 = require("./shipment-line-item.entity");
var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus["DRAFT"] = "draft";
    ShipmentStatus["BOOKED"] = "booked";
    ShipmentStatus["PACKED"] = "packed";
    ShipmentStatus["DISPATCHED"] = "dispatched";
    ShipmentStatus["IN_TRANSIT"] = "in_transit";
    ShipmentStatus["DELIVERED"] = "delivered";
    ShipmentStatus["ON_HOLD"] = "on_hold";
    ShipmentStatus["RTO"] = "rto";
    ShipmentStatus["CANCELLED"] = "cancelled";
})(ShipmentStatus || (exports.ShipmentStatus = ShipmentStatus = {}));
let Shipment = class Shipment {
};
exports.Shipment = Shipment;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Shipment.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Index)({ unique: true }),
    (0, typeorm_1.Column)({ length: 24 }),
    tslib_1.__metadata("design:type", String)
], Shipment.prototype, "shipmentNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => order_entity_1.Order, (order) => order.shipments, { onDelete: 'CASCADE', nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'orderId' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof order_entity_1.Order !== "undefined" && order_entity_1.Order) === "function" ? _a : Object)
], Shipment.prototype, "order", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'orderId' }),
    tslib_1.__metadata("design:type", Number)
], Shipment.prototype, "orderId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 80 }),
    tslib_1.__metadata("design:type", String)
], Shipment.prototype, "warehouseLocation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'int', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "destinationAddressId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'varchar', length: 80, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "carrierCode", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'varchar', length: 80, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "carrierName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'varchar', length: 120, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "serviceCode", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'varchar', length: 120, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "serviceName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'varchar', length: 120, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "awbNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'varchar', length: 120, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "trackingNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: ShipmentStatus, default: ShipmentStatus.DRAFT }),
    tslib_1.__metadata("design:type", String)
], Shipment.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: 1 }),
    tslib_1.__metadata("design:type", Number)
], Shipment.prototype, "packageCount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    tslib_1.__metadata("design:type", Number)
], Shipment.prototype, "totalWeightGrams", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'int', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "lengthCm", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'int', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "widthCm", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'int', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "heightCm", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "labelUrl", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "manifestUrl", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'varchar', length: 120, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "pickupRequestId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'json', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "bookingRequest", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'json', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "bookingResponse", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'json', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "latestWebhookPayload", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "notes", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "statusReason", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'datetime', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "bookedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'datetime', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "packedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'datetime', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "dispatchedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'datetime', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Shipment.prototype, "deliveredAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => shipment_line_item_entity_1.ShipmentLineItem, (shipmentLineItem) => shipmentLineItem.shipment, {
        cascade: true,
        eager: true,
    }),
    tslib_1.__metadata("design:type", Array)
], Shipment.prototype, "shipmentLineItems", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_j = typeof Date !== "undefined" && Date) === "function" ? _j : Object)
], Shipment.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_k = typeof Date !== "undefined" && Date) === "function" ? _k : Object)
], Shipment.prototype, "updatedAt", void 0);
exports.Shipment = Shipment = tslib_1.__decorate([
    (0, typeorm_1.Entity)('shipments')
], Shipment);
